export const portfolioRoutes = {
  overview: "",
  newProject: "new",
  userLookup: "users-lookup",
  addAdmin: "add-admin",
  bulkUploadAddresses: "import-addresses",
  createMassMessage: "message/new",
  createMassSurvey: "survey/new",
  tickets: "tickets",
  ticketSettings: "ticket-settings",
  chats: "chats",
  integrations: "integrations",
  manageAiIntegration: "integrations/manage/ai",
  manageRemsIntegration: "integrations/manage/rems",
  manageILoqIntegration: "integrations/manage/iloq",
  integrationDetails: "integrations/:id",
  analyticsOverview: "analytics",
  analyticsCommunityFeed: "analytics/community-feed",
  analyticsSentiment: "analytics/sentiment",
  analyticsEvents: "analytics/events",
  analyticsTickets: "analytics/tickets",
  analyticsBookings: "analytics/bookings",
  analyticsExplore: "analytics/explore",
  analyticsExploreEvents: "analytics/explore/events",
  analyticsExploreBookings: "analytics/explore/bookings",
  analyticsExploreCommunityFeed: "analytics/explore/community-feed",
  analyticsExploreSentiment: "analytics/explore/sentiment",
  analyticsExploreTickets: "analytics/explore/tickets",
} as const;

export type PortfolioRouteParams = {
  overview: {
    owner?: string;
    maintenance?: string;
    city?: string;
    projectIds?: string;
    search?: string;
    startDate?: string;
  };
  overview_LEGACY: {
    owner?: string;
    maintenance?: string;
    city?: string;
    period?: string;
  };
  tickets: {
    tab?: string;
    search?: string;
    sort?: string;
    ratings?: string;
    isUnreadOnly?: string;
    visibility?: string;
    statusKeys?: string;
    categoryNames?: string;
    assigneeAccountIds?: string;
    assigneeMode?: string;
    owner?: string;
    maintenance?: string;
    projectIds?: string;
  };
  chats: {
    owner?: string;
    maintenance?: string;
    city?: string;
    search?: string;
  };
  userLookup: {
    city?: string;
    street?: string;
    house?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    statuses?: string;
    roleTypes?: string;
  };
};

export type PortfolioRouteStates = {
  chats: {
    activeChatId?: string;
    activeChatType?: "private" | "group";
  };
};
